import {useGeoSearch} from "react-instantsearch";
import type {GeoHit} from "instantsearch.js";
import {type Practice} from "./PracticesMapContainer.tsx";
import {useApp} from "../providers/AppProvider.tsx";
import {MapIcon, Phone} from "lucide-react";
import clsx from "clsx";
import {useSortedPractices} from "../hooks/useSortedPractices.tsx";
import {trackContactClick, trackViewProviderClick} from "../lib/algolia-insights";

const MobilePracticesList = () => {

    const {state} = useApp();

    const {
        items
    } = useGeoSearch<GeoHit<Practice>>();

    const sortedPractices = useSortedPractices(items);


    return (
        <div className={clsx(
            "practicesList pt-4 pb-6 px-4",
        )}>
            {sortedPractices.map((practice) => (<div key={practice.id}>
                <div
                    className={
                        clsx(
                            `text-white relative block transition-transform border-b-1 border-white/20 py-2`,
                            {'bg-green-700/30 px-4 shadow-xl rounded-md': practice.id === state.selectedPractice?.id},
                        )}
                >
                    {state.userPickedLocation &&
                        <p className={"text-[10px] opacity-70 font-light absolute top-1 left-0"}>
                            {practice._rankingInfo?.geoDistance.toFixed(2)} mi. from you
                        </p>}

                    <div
                        className={`body rounded-b-lg py-2 `}>
                        <div className="flex justify-between gap-2">
                            <div className={"flx-grow"}>
                                <div className={"max-w-[290px]"}>
                                    <a href={`/hormone-replacement-therapy-provider/${practice.slug}`}
                                       className={`focus:opacity-70`}
                                       onClick={() => trackViewProviderClick(practice)}>
                                        <h2 className={"font-semibold text-md"}>
                                            {practice.name}
                                        </h2>
                                    </a>
                                    <span className={"block mb-2 text-sm opacity-85 "}>
                                {practice.address}
                                </span>
                                    <a href={`/hormone-replacement-therapy-provider/${practice.slug}`}
                                       className={"p-2 px-5 bg-green-700 text-md mt-2 inline-block focus:opacity-70"}
                                       onClick={() => trackViewProviderClick(practice)}>
                                        View Provider
                                    </a>
                                </div>
                            </div>
                            <div className={"flex-none"}>
                                <div className={"flex gap-2"}>
                                    <a target={'_blank'}
                                       href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(practice.address)}`}
                                       className={"text-center gap-1 text-xs font-normal uppercase hover:text-green-600 focus:opacity-55"}
                                       onClick={() => trackContactClick(practice, 'directions')}>
                                        <span
                                            className={"pointer-events-none inline-block p-2 text-white rounded-full bg-green-600"}>
                                            <MapIcon size={24}/></span>
                                        <span
                                            className={"block"}>Directions</span>
                                    </a>

                                    <a href={`tel:${practice.phone_formatted}`}
                                       className={"text-center px-4 gap-1 text-xs font-normal uppercase hover:text-green-600"}
                                       onClick={() => trackContactClick(practice, 'phone')}>
                                        <span
                                            className={"pointer-events-none inline-block p-2 text-white rounded-full bg-green-600"}><Phone
                                            fill={'#fff'} strokeWidth={0} size={24}/></span>
                                        <span
                                            className={"block"}>Call</span>
                                    </a>
                                </div>
                                <div className={"mt-2 text-right opacity-40"}>
                                    <div className={"text-[10px] uppercase"}>Serving</div>
                                    <div className={"flex gap-2 justify-end"}>
                                        <span
                                            className={"uppercase text-[10px] font-black tracking-widest text-green-700 inline-block px-1 py-0.5 bg-green-200"}>Women</span>
                                        <span
                                            className={"uppercase text-[10px] font-black tracking-widest text-blue-700 inline-block px-1 py-0.5 bg-blue-200"}>Men</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>))}
        </div>
    )
}

export default MobilePracticesList;